import { createContext } from "preact";
import { useContext } from "preact/hooks";

export const Path = createContext({
  path: "/",
});

export const usePath = () => useContext(Path);
